import { render, staticRenderFns } from "./Texts.vue?vue&type=template&id=19de3ef8&scoped=true"
import script from "./Texts.vue?vue&type=script&lang=js"
export * from "./Texts.vue?vue&type=script&lang=js"
import style0 from "./Texts.vue?vue&type=style&index=0&id=19de3ef8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19de3ef8",
  null
  
)

export default component.exports